export enum AppSubscriptionKey {
  FrontSubscription = 'Front:Subscription'
}
